import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import MaterialTable, { MTableToolbar } from 'material-table'
import { ButtonListEdit } from 'theme'
import Edit from '@material-ui/icons/Edit'
import { ERROR_MESSAGE_NO_PROGRAMS_ASSIGNED } from '../../actions/action-constants'
import SnackbarError from '../../components/snackbar/snackbar-error'
import CONTEXT_USER_FOR_CLASS_COMPONENTS_FOR_COMPONENTS  from 'components/UserContext-FOR-CLASS-COMPONENTS/UserContext-FOR-CLASS-COMPONENTS'
class Clients extends Component {
  static contextType = CONTEXT_USER_FOR_CLASS_COMPONENTS_FOR_COMPONENTS
  constructor (props) {
    super(props)
    this.state = {
      data: [],
      columns: [
        { title: 'Sys ID', field: 'id' },
        { title: 'CP / REG ID', field: 'regid' },
        { title: 'Name', field: 'lcommafname' },
        { title: 'Program', field: 'programdescription' },
        { title: 'HD Elg Date', field: 'clientrrchdeligibilitydate' },
        { title: 'Proj Rls Dte', field: 'referralprojectedreleasedate' },
        { title: 'Discharge Dte', field: 'clientdischargedate' }
      ]
    }
  }

  componentDidMount () {
    const c_USER = this.context
    this.props.getClients(c_USER.id)
    this.props.getProgramsAssignedToLoginList(c_USER.id)
  }

  render () {
    return (
      // <div className={classes.root}>
      <div>
        {this.props.programsAssigned.length <= 1 ? (
          <div>
            <h4>{ERROR_MESSAGE_NO_PROGRAMS_ASSIGNED}</h4>
            <SnackbarError
              variant='error'
              message={ERROR_MESSAGE_NO_PROGRAMS_ASSIGNED}
            />
          </div>
        ) : (
          <div style={{ maxWidth: '100%' }}>
            {/* <ClientsToolbar /> */}
            <MaterialTable
              title='Clients'
              // onRowSelected='10'
              // rowData='10'
              // rowsperpage='10'
              // rows='10'
              rowsPerPage='10'
              columns={this.state.columns}
              data={this.props.clients}
              options={{
                // search
                search: true,
                // header grouping
                grouping: true,
                // or
                // column filtering
                // filtering: true,
                // CSV export
                // pagination settings
                // show paging buttons
                // paging:false,
                // default items per page
                pageSize: 10,
                // paging options
                pageSizeOptions: [10, 25, 50, 100],
                // ???
                // columnsButton:false,
                // move buttons to right side of list
                // actionsColumnIndex: -1,
                // styling otions
                rowStyle: { height: '20px' },
                maxBodyHeight: 700,
                // export data buttons
                // exportButton: true,
                // default filename
                exportFileName: 'CPCMexport-Clients'
                // comma delimited
                // exportDelimiter: ',',
              }}
              actions={[
                {
                  icon: 'edit',
                  tooltip: 'Edit Client',
                  onClick: (event, rowData) => {
                    this.props.history.push('/clients/' + rowData.id)
                  }
                }
              ]}
              components={{
                Toolbar: props => (
                  <div
                    style={{
                      background:
                        'linear-gradient(45deg, #a9ffa5 10%, #fff 70%)', // blue / fade light blue
                      color: 'white'
                    }}>
                    <MTableToolbar {...props} />
                  </div>
                ),
                Action: props => (
                  <ButtonListEdit
                    onClick={event => props.action.onClick(event, props.data)}>
                    <Edit />
                  </ButtonListEdit>
                )
              }}
            />
          </div>
        )}
      </div>
    )
  }
}
Clients.propTypes = {
  className: PropTypes.string
}
export default withRouter(Clients)
